import React from "react";
import IconSvg from "./IconSvg";
import "./style.css";

const ThreePAnalysisCard = ({ data, onViewStudents }) => {
  if (!data) return null;
  const {
    description,
    dimensions,
    alignmentCategories,
    insightsAndRecommendations,
    studentsToDisplayAccordingToAlignment
  } = data;
  const handleViewStudents = (label) => {
    const filtered_user_id = studentsToDisplayAccordingToAlignment.filter((student) => student.label === label).flatMap((student) => student.user_ids)
    onViewStudents(filtered_user_id)
  }

  return (
    <section className="mb-6">
      <h2 className="section-heading">
        <IconSvg
          path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          className="h-5 w-5 mr-2 text-primary-600"
        />
        Performance Insights
        <div className="tooltip-wrapper">
          <IconSvg
            path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            className="h-4 w-4 text-gray-400"
          />
          <div className="tooltip-content w-64">
            Deep analysis of student performance patterns and insights for career development.
          </div>
        </div>
      </h2>

      <div className="card p-4">
        <div className="flex justify-between items-start mb-3">
          <span className="font-medium text-gray-800 flex items-center">
            <div className="three-p-header-icon-wrapper">
              <IconSvg
                path="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                className="three-p-header-icon"
              />
            </div>
            3P Analysis
            <div className="tooltip-wrapper">
              <IconSvg
                path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                className="h-3-5 w-3-5 text-gray-400"
              />
              <div className="tooltip-content w-64">
                Analysis of how well aligned are a student's profile, preferences,
                and performance dimensions. CareerCarve's proprietary framework
                for career path optimization.
              </div>
            </div>
          </span>
        </div>

        <div className="flex items-center three-p-description">
          {description}
        </div>
        <div className="mb-6">
          <h4 className="text-sm font-medium text-gray-800 mb-3">
            The 3 Dimensions
          </h4>
          <div className="three-p-dimensions-grid">
            {dimensions.map((dim, index) => (
              <div
                key={dim.name}
                className={`three-p-dimension-card ${dim.baseColor}`}
              >
                <div
                  className={`three-p-dimension-header ${dim.baseColor}`}
                >
                  <div className="flex items-center">
                    <div
                      className={`three-p-dimension-icon-wrapper ${dim.baseColor}`}
                    >
                      <IconSvg
                        path={dim.iconPath}
                        className="h-4 w-4"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        stroke="none"
                      />
                    </div>
                    <div>
                      <span className="three-p-dimension-title">
                        <span>{index + 1}.</span>{" "}{dim.name}
                      </span>
                      <span className="three-p-dimension-subtitle">{dim.subtext}</span>
                    </div>
                  </div>
                </div>
                <div className="three-p-dimension-body">
                  <p className="three-p-dimension-description">{dim.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-6">
          <h4 className="text-sm font-medium text-gray-800 mb-3">
            Alignment Categories
          </h4>
          <div className="three-p-alignment-grid">
            {alignmentCategories.map((category) => (
              <div
                key={category.label}
                className="three-p-alignment-card"
              >
                <div className="three-p-alignment-header">
                  <div className="flex justify-between items-center">
                    <div className="flex items-center">
                      <div className={`three-p-alignment-icon-container ${category.alignment}`}>
                        <div className="three-p-alignment-icon-wrapper">
                          <div className="three-p-alignment-circle p1">
                            <span>P1</span>
                          </div>
                          <div className="three-p-alignment-circle p2">
                            <span className="text-xxs font-bold text-purple-600">P2</span>
                          </div>
                          <div className="three-p-alignment-circle p3">
                            <span className="text-xxs font-bold text-green-600">P3</span>
                          </div>

                          {/* Central indicator */}
                          <div className="three-p-alignment-indicator-base"></div>
                          <div className={`three-p-alignment-indicator-color ${category.color}`}>
                            <IconSvg
                              path={category.iconPath}
                              className="h-3 w-3 text-white"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              stroke="none"
                            />
                          </div>
                        </div>
                      </div>

                      <h5
                        className={`three-p-alignment-title text-${category.color}-500`}
                      >
                        {category.label}
                      </h5>
                    </div>
                    <p className={`three-p-alignment-percentage text-${category.color}-500`}>
                      {Math.round(category.percentage)}%
                    </p>
                  </div>
                </div>
                <div className="three-p-alignment-body">
                  <p className="three-p-alignment-description">
                    {category.description}
                  </p>
                  <button
                    onClick={() => handleViewStudents(category.label)}
                    className="three-p-alignment-button"
                  >
                    <IconSvg
                      path="M15 12a3 3 0 11-6 0 3 3 0 016 0zM2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      className="h-4 w-4 mr-1"
                    />
                    View these students
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="three-p-recommendations">
          <h5 className="three-p-recommendations-title">
            Key Insights & Recommendations:
          </h5>
          <div className="">
            {insightsAndRecommendations.map((item, index) => (
              <div key={index} className="three-p-recommendation-item ">
                <div className="three-p-recommendation-icon-wrapper">
                  <IconSvg
                    path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    className={`h-4 w-4 text-${item.type}`}
                  />
                </div>
                <span className="three-p-recommendation-text">
                  <span className="font-medium text-gray-700">
                    {item.text.split(":")[0]}:
                  </span>{" "}
                  {item.text.split(":")[1]}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThreePAnalysisCard;
